import { render, staticRenderFns } from "./GeneralTable.vue?vue&type=template&id=10ab6887&scoped=true&"
import script from "./GeneralTable.vue?vue&type=script&lang=js&"
export * from "./GeneralTable.vue?vue&type=script&lang=js&"
import style0 from "./GeneralTable.vue?vue&type=style&index=0&id=10ab6887&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ab6887",
  null
  
)

export default component.exports